const HOURS_WANTED_LABELS: Readonly<Record<string, string>> = {
    under_10: 'under 10 hrs/wk',
    hours_10_20: '10–20 hrs/wk',
    hours_20_30: '20–30 hrs/wk',
    hours_30_40: '30–40 hrs/wk',
    hours_40_plus: '40+ hrs/wk',
};

export function formatHoursWanted(value: string): string {
    return HOURS_WANTED_LABELS[value] ?? value;
}
